import { render, staticRenderFns } from "./TimelineEditTitleDialog.vue?vue&type=template&id=58356f8a&scoped=true"
import script from "./TimelineEditTitleDialog.vue?vue&type=script&lang=ts"
export * from "./TimelineEditTitleDialog.vue?vue&type=script&lang=ts"
import style0 from "./TimelineEditTitleDialog.vue?vue&type=style&index=0&id=58356f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58356f8a",
  null
  
)

export default component.exports